import { Link } from "react-router-dom";

const footerLinks = [
  {
    title: "快速导航",
    links: [
      { to: "/", label: "首页" },
      { to: "/category/works", label: "作品集" },
      { to: "/category/gallery", label: "图片集" },
      { to: "/category/news", label: "新闻动态" },
    ],
  },
  {
    title: "更多内容",
    links: [
      { to: "/category/discussion", label: "粉丝热议" },
      { to: "/category/interview", label: "专访报道" },
      { to: "/category/video", label: "视频专区" },
      { to: "/about", label: "关于我们" },
    ],
  },
  {
    title: "关注我们",
    links: [
      { to: "#", label: "新浪微博", external: true },
      { to: "#", label: "微信公众号", external: true },
      { to: "#", label: "Twitter", external: true },
      { to: "#", label: "Instagram", external: true },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-semibold text-foreground-950">
                <span className="text-primary-500">樱</span>之资料站
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              苍井樱官方中文资讯平台，为华语粉丝提供最全面、最权威的苍井樱个人资料、作品集与最新动态。
            </p>
          </div>
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-foreground-950 mb-3">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-2">
                {group.links.map((link) =>
                  link.external ? (
                    <li key={link.label}>
                      <a
                        href={link.to}
                        className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                        rel="nofollow noopener noreferrer"
                        target="_blank"
                      >
                        {link.label}
                      </a>
                    </li>
                  ) : (
                    <li key={link.label}>
                      <Link
                        to={link.to}
                        className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                      >
                        {link.label}
                      </Link>
                    </li>
                  )
                )}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 苍井樱官方资料站. 本站为非官方粉丝资讯平台，所有内容仅供粉丝交流参考。
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-500 hover:bg-primary-100 transition-colors"
              aria-label="新浪微博"
              rel="nofollow noopener noreferrer"
            >
              <i className="ri-weibo-line text-sm"></i>
            </a>
            <a
              href="#"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-500 hover:bg-primary-100 transition-colors"
              aria-label="微信"
              rel="nofollow noopener noreferrer"
            >
              <i className="ri-wechat-line text-sm"></i>
            </a>
            <a
              href="#"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-500 hover:bg-primary-100 transition-colors"
              aria-label="Twitter"
              rel="nofollow noopener noreferrer"
            >
              <i className="ri-twitter-x-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}